// necessary dependencies //
import { React, useState } from 'react';
import { Link } from 'react-router-dom';
import Fade from 'react-reveal/Fade';
// css //
import styles from './Template.module.scss';
// images/icons //
import { Line2 } from '../../images/icons/Line2'
import { Macbook } from '../../images/pictures/Macbook'
import { BiLeftArrowAlt, BiRightArrowAlt } from 'react-icons/bi'
import background from '../../images/pictures/background2.png'

import ardawalika from '../../images/pictures/ardawalika_home.png'
import ardawalika_paket from '../../images/pictures/ardawalika_paket.png'
import ardawalika_dokumentasi from '../../images/pictures/ardawalika_dokumentasi.png'


const Ardawalika = () => {
    const [number, setNumber] = useState(1)
    const data = [
        {
            id: 1,
            title: "Homepage",
            next: "Package",
            prev: "Documentation",
            src: ardawalika,
            desc1: `Welcome to Ardawalika! Our dedicated team has poured their passion for craftmanship into creating this lovely even organizer website. This website was created within only two weeks using EJS to create the frontend of the website and SCSS as the makeup for the frontend! Even though we did not have much time to complete this website we still can't wait to share our lovely modest website with you! `,
            desc2: `On our homepage we have carefully created the kind of event organizer website that will help you have a pleasant time in helping you arrange your lovely event! We also present to you our main events that we usually help our clients with such as corporate event, wedding event, along with family event! We're proud of our works and to make you even more convinced we have also laid out our works' documentations along with our clients' reviews!`
        },
        {
            id: 2,
            title: "Package",
            next: "Documentation",
            prev: "Homepage",
            src: ardawalika_paket,
            desc1: `On this page we present to you the type of event that we offer, to help convince our potential clients we have enticingly written our specialisation for each type of event! For each event type we also offer different type of package each with different price and benefits, if a certain event package suits your need dont hesitate to click on the card to get more information!`
        },
        {
            id: 3,
            title: "Documentation",
            next: "Homepage",
            prev: "Package",
            src: ardawalika_dokumentasi,
            desc1: `Our works are our pride and joy, on this page we present to you our documentations in helping our clients carry out their vision with love and joy, every event is different and we always try to bring out the kind of personality and atmosphere that our clients have in their mind and bring them out to life ♥️`
        },
    ]
    const [temp, setTemp] = useState(data)

    const cont = () => {
        console.log("ini cont")
        //setNumber(number+1)
        if (number === data.length) {
            setNumber(1)
        } else {
            setNumber(number + 1)
        }
        console.log("number", number, "data length", data.length)
    }

    const prev = () => {
        console.log("ini prev")
        if (number === 1) {
            setNumber(data.length)
        } else {
            setNumber(number - 1)
        }
        console.log("number", number)
    }
    console.log("numberrrrrrrr", number)
    return (
        <>
            <div className={styles.template_header_top} style={{ backgroundImage: `url(${background})`, background: `linear-gradient(rgba(0, 0, 0, 0), transparent), url(${background})`, backgroundRepeat: `no-repeat`, backgroundSize: `cover`, backgroundPosition: `center`, height: `37rem` }}>
            </div>
            <div className={styles.template_container}>
                {/* {temp.map((data) => {
                        return(
                            // <p>{data['title']}</p>
                            <>
                          {data['id'] === 1 ? <p>yes</p> : <p>no</p>}
                        </>
                        )
                })} */}
                <div className={`${styles.template_container_details} container`}>
                    <Fade top cascade>
                        <div className={styles.template_header_text}>
                            <a href="https://drive.google.com/file/d/1E0Cf-uulL8h2nf6htuUiY9_6MH6a-XOh/view?usp=sharing">DEMO</a>
                            <h1 className={`${styles} bold-32`}>Ardawalika</h1>
                            <a href="https://gitlab.com/ajisetiaji101/ardawalika">REPO</a>
                        </div>
                    </Fade>
                </div>
                {temp.map((data) => {
                    return (
                        // <p>{data['title']}</p>
                        <>
                            {data['id'] === number ?
                                <>
                                    <div className={styles.template_mac}>
                                        <div className={styles.template_details}>
                                            <Macbook />
                                            <div className={styles.template_images}>
                                                {/* <Fade big> */}
                                                <img src={data['src']} className={styles.work_image} />
                                                {/* </Fade> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={styles.template_homepage}>
                                        <Fade big>
                                            <ul>
                                                <li onClick={(e) => prev()}><BiLeftArrowAlt className={styles.arrow} style={{ color: 'Blue', position: 'relative', fontSize: '32px' }} /></li>
                                                <li>{data['title']}</li>
                                                <li onClick={(e) => cont()}><BiRightArrowAlt style={{ color: 'Blue', position: 'relative', fontSize: '32px' }} /></li>
                                            </ul>
                                        </Fade>
                                        <Line2 />
                                        <Fade big>
                                            <div className={styles.template_details}>
                                                <p>{data['desc1']}</p>
                                                <p>{data['desc2']}</p>
                                            </div>
                                        </Fade>
                                        <Line2 />
                                        <Fade bottom cascade>
                                            <Link to={`/`} className={styles.button}>
                                                <button> * Back to Home *</button>
                                            </Link>
                                        </Fade>
                                    </div>
                                </>
                                : null
                            }
                        </>
                    )
                })}
                {/* <div className={styles.template_mac}>
                    <div className={styles.template_details}>
                        <Macbook/>
                        <div className={styles.template_images}>
                            <img src={ardawalika} className={styles.work_image} />
                        </div>
                    </div>
                </div> */}
                {/* <div className={styles.template_homepage}>
                    <ul>
                        <li>next</li>
                        <li>homepage</li>
                        <li>next</li>
                    </ul>
                    <Line2/>
                    <div className={styles.template_details}>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer tincidunt augue ac metus aliquam aliquet. Donec non fringilla purus. Suspendisse ac iaculis tellus, et convallis arcu. Vivamus sed laoreet velit, in malesuada massa. Cras dapibus nec mauris ut feugiat. Nulla facilisi. Etiam nec risus ut felis feugiat sollicitudin non ac lorem. Ut vel purus blandit, pharetra velit ac, lacinia elit. Sed eget felis lobortis, lobortis odio vel, consequat velit. Duis porta, nisl ac ultrices consequat, nisl nisl convallis nunc, quis convallis ipsum magna sed lacus. Nunc fringilla quis libero et sagittis.</p> 
                        <p>Nullam vel elementum sapien. Cras efficitur tellus ut ipsum varius dictum nec vel ligula. Suspendisse lobortis dictum dolor, ut commodo diam volutpat et. Suspendisse porta turpis ut arcu pretium faucibus. Cras placerat augue faucibus, vulputate leo non, elementum ipsum. Fusce at euismod odio, ut vehicula ligula. Pellentesque aliquet fermentum lectus nec vulputate. Fusce enim nibh, posuere nec blandit eu, lacinia a risus. Curabitur suscipit ipsum et posuere tristique. Proin ac erat blandit, luctus mauris a, tincidunt libero. Ut tincidunt at justo in ultricies. Quisque lacus mauris, ornare nec rutrum in, posuere sit amet risus. Cras vitae fringilla ligula, egestas fermentum mauris. Aliquam feugiat odio at ex tincidunt, at pharetra sem sagittis. Cras et scelerisque ipsum.</p>    
                    </div>
                    <Line2/>
                    <Link to={`/`} className={styles.button}>
                        <button> * Back to Home *</button>
                    </Link>
                </div> */}
            </div>
        </>
    )
}

export default Ardawalika